


















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class CreditCardIcon extends Vue {
  @Prop() cardBrand!: string
}
